import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { IDashboard } from 'app/models/dashboard/dashboard';
import { IVoucherSearchResult } from 'app/models/vouchers/voucher.search.result';
import { VoucherLetterUpload } from 'app/models/vouchers/voucher-letter-upload';
import { VoucherLetter } from 'app/models/vouchers/voucher-letter';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { VoucherService } from 'app/services/voucher-service';
import { OregonWellAzueService } from 'app/services/azure-service';
import { DialogEditApplicationComponent } from '../vouchers/edit/application-edit-dialog';
import { SendLetterComponent } from '../vouchers/letters/send/send-letter.component';
import { EditSampleComponent } from '../well/samples/edit/edit-samples.component';
import { DialogEditVoucherComponent } from '../vouchers/edit/voucher-edit-dialog';
import { AttachLetterComponent } from '../vouchers/letters/attach/attach-letter.component';
import { NotEligibleVoucherLetterComponent } from '../vouchers/letters/voucher/not-eligible/not-eligible-voucher-letter.component';
import { LubgwmaTestingVoucherLetterComponent } from '../vouchers/letters/voucher/lubgwma/lubgwma-testing-voucher-letter.component';
import { LubgwmaTreatmentVoucherLetterComponent } from '../vouchers/letters/voucher/lubgwma/lubgwma-treatment-voucher-letter.component';
import { HouseholdService } from 'app/services/household-service';
import { DialogEditHouseholdComponent } from '../households/edit/household-edit-dialog';
import { HouseholdLetterUpload } from 'app/models/household/household-letter-upload';
import { HouseholdExceedenceLetterComponent } from '../households/letters/nitrate-exceedance/household-exceedence-letter.component';
import { AttachHouseholdLetterComponent } from '../households/letters/attach-household-letter.component';
import { AuthService } from '@shared/auth/auth.service';
import { SharedService } from '@shared/services/shared.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})

export class DashboardComponent implements OnInit {

  pageSize = 10;
  public processingVouchers: boolean = false;
  public processingHouseholds: boolean = false;
  dashboardData: IDashboard = {
    newApplications: [],
    totalNewVoucherApplications: 0,
    totalLubgwmaVoucherImports: 0,
    totalNitrateExceedanceMissingIndicator: 0,
    totalVouchersWithExceedanceNotIndicated: 0,
    lettersTasks: [],
    newestVouchers: [],
    householdLetterTasks: [],
    totalHouseholdInteractionsApprovalNeeded: 0,
    totalHouseholdTiedToMultipleHousingUnits: 0
  }

  // New applications
  displayedColumnsNewApplications: string[] = ['id', 'applicationType', 'wellAddress1', 'wellCity', 'wellZip', 'wellCounty', 'wellTag', 'applicantContactName', 'selfGeneratedVoucherIdentifer'];
  dataSourceNewApplications = new MatTableDataSource<IVoucherSearchResult>();
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  // Newest vouchers
  displayedColumnsNewest: string[] = ['id', 'applicationType', 'wellAddress', 'wellCity', 'wellZip', 'wellCounty', 'wellLabelTagNumber', 'applicantContactName'];
  dataSourceNewest = new MatTableDataSource<IVoucherSearchResult>();
  @ViewChild('TablePaginatorNewest') paginatorNewest: MatPaginator;
  @ViewChild('TableSortNewest') sortNewest: MatSort;

  //Voucher Letter Tasks
  attachment: VoucherLetterUpload = undefined;
  displayedColumnsLetterTasks: string[] = ['voucherId', 'applicationType', 'letterType', 'complete', 'actions'];
  dataSourceLetterTasks = new MatTableDataSource<VoucherLetter>();
  @ViewChild('TablePaginator2') paginator2: MatPaginator;
  @ViewChild('TableSort2') sort2: MatSort;

  //Household Letter Tasks
  householdAttachment: HouseholdLetterUpload = undefined;
  displayedColumnsHouseholdLetterTasks: string[] = ['householdId', 'address', 'sampleId', 'letterType', 'complete', 'actions'];
  dataSourceHouseholdLetterTasks = new MatTableDataSource<VoucherLetter>();
  @ViewChild('TablePaginatorHouseholdLetters') paginatorHouseholdLetters: MatPaginator;
  @ViewChild('TableSortHouseholdLetters') sortHouseholdLetters: MatSort;

  filterTableNewApplications(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSourceNewApplications.filter = value.trim().toLowerCase();
  }

  filterTableNewest(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSourceNewest.filter = value.trim().toLowerCase();
  }

  filterTableLetterTasks(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSourceLetterTasks.filter = value.trim().toLowerCase();
  }

  filterTableHouseholdLetterTasks(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSourceHouseholdLetterTasks.filter = value.trim().toLowerCase();
  }

  constructor(public oregonWellService: OregonWellDataService,
    public authService: AuthService,
    public voucherService: VoucherService,
    public householdService: HouseholdService,
    public sharedService: SharedService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    public oregonWellAzureService: OregonWellAzueService) { }

  ngOnInit() {
    this.loadDashboard();

    //Load the Household Letter Tasks
    this.loadHouseholdLetterTasks();
  }

  loadDashboard() {
    this.processingVouchers = true;

    this.voucherService.getVoucherDashboard(this.oregonWellService.dashboardCounty).subscribe(
      result => {
        this.dashboardData.lettersTasks = result.lettersTasks;
        this.dashboardData.newApplications = result.newApplications;
        this.dashboardData.newestVouchers = result.newestVouchers;
        this.dashboardData.totalVouchersWithExceedanceNotIndicated = result.totalVouchersWithExceedanceNotIndicated;
        //JJ - Added in, what am I doing here? 
        this.dashboardData.totalHouseholdInteractionsApprovalNeeded = result.totalHouseholdInteractionsApprovalNeeded;
        this.dashboardData.totalHouseholdTiedToMultipleHousingUnits = result.totalHouseholdTiedToMultipleHousingUnits;

        this.dashboardData.totalNewVoucherApplications = result.totalNewVoucherApplications;
        this.dashboardData.totalNitrateExceedanceMissingIndicator = result.totalNitrateExceedanceMissingIndicator;

        // Azure direct query
        this.oregonWellAzureService.getVoucherImportCount(this.voucherService.lubgwmaTestingVoucherType).then((value) => {
          this.dashboardData.totalLubgwmaVoucherImports = +value;
          this.oregonWellAzureService.getVoucherImportCount(this.voucherService.lubgwmatestingSurvey123VoucherType).then((value) => {
            this.dashboardData.totalLubgwmaVoucherImports = this.dashboardData.totalLubgwmaVoucherImports + +value;
          });
        });

        this.dataSourceNewApplications = new MatTableDataSource<IVoucherSearchResult>(this.dashboardData.newApplications);
        this.dataSourceNewest = new MatTableDataSource<IVoucherSearchResult>(this.dashboardData.newestVouchers);
        this.dataSourceLetterTasks = new MatTableDataSource<VoucherLetter>(this.dashboardData.lettersTasks);
        this.processingVouchers = false;
      },
      error => {
        console.log(error);
        this.processingVouchers = false;
      },
      () => {
        this.dataSourceNewApplications.paginator = this.paginator;
        this.dataSourceNewApplications.sort = this.sort;

        this.dataSourceNewest.paginator = this.paginatorNewest;
        this.dataSourceNewest.sort = this.sortNewest;

        this.dataSourceLetterTasks.paginator = this.paginator2;
        this.dataSourceLetterTasks.sort = this.sort2;
      }
    );

  }

  loadHouseholdLetterTasks() {
    this.processingHouseholds = true;
    this.dashboardData.householdLetterTasks = [];
    //load exceedance letters not generated
    this.householdService.getHouseholdExceedanceLettersNotGenerated().subscribe(
      result => {
        if(result != null && result.length > 0) {
          this.dashboardData.householdLetterTasks = this.dashboardData.householdLetterTasks.concat(result);    
        }
        //load no exceedance letters not generated
        this.householdService.getHouseholdNoExceedanceLettersNotGenerated().subscribe(
          result => {
            if(result != null && result.length > 0) {
              this.dashboardData.householdLetterTasks = this.dashboardData.householdLetterTasks.concat(result);   
            }
            //load letters missing sent info
            this.householdService.getHouseholdLettersMissingSentInfo().subscribe(
              result => {
                if(result != null && result.length > 0) {
                  this.dashboardData.householdLetterTasks = this.dashboardData.householdLetterTasks.concat(result);                   
                  this.setHouseholdTable();
                  this.processingHouseholds = false;
                }
                else {
                  this.setHouseholdTable();
                  this.processingHouseholds = false;
                }
              },
              error => {
                this.toastr.error("Unable to load Household All Letter Tasks: Missing Sent Info");
                this.setHouseholdTable();
                this.processingHouseholds = false;
              });
          },
          error => {
            this.toastr.error("Unable to load Household All Letter Tasks: No Exceedances");
            this.setHouseholdTable();
            this.processingHouseholds = false;
          });
      },
      error => {
        this.toastr.error("Unable to load Household All Letter Tasks: Exceedances");
        this.processingHouseholds = false;
      },
      () => {
      });
  }

  setHouseholdTable() {
    this.dataSourceHouseholdLetterTasks = new MatTableDataSource<VoucherLetter>(this.dashboardData.householdLetterTasks);
    this.dataSourceHouseholdLetterTasks.paginator = this.paginatorHouseholdLetters;
    this.dataSourceHouseholdLetterTasks.sort = this.sortHouseholdLetters;
  }

  onCountyChange() {
    this.loadDashboard();
  }

  editHousehold(householdId: number) {
    const dialogRef = this.dialog.open(DialogEditHouseholdComponent, {
      width: '90%',
      data: householdId,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadHouseholdLetterTasks();
    });
  }

  editVoucherApplication(applicationId: number) {
    const dialogRef = this.dialog.open(DialogEditApplicationComponent, {
      width: '90%',
      data: applicationId,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadDashboard();
    });
  }

  sendLetter(letterId: number, voucherId: number) {
    let letter = this.dashboardData.lettersTasks.find(l => l.id == letterId);
    const dialogRef = this.dialog.open(SendLetterComponent, {
      width: '70%',
      data: letter,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadVoucherLetterTasks();
    });
  }

  sendHouseholdLetter(letterId: number) {
    let letter = this.dashboardData.householdLetterTasks.find(l => l.id == letterId);
    const dialogRef = this.dialog.open(SendLetterComponent, {
      width: '70%',
      data: letter,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadHouseholdLetterTasks();
    });
  }

  editSample(sampleId: number) {
    const dialogRef = this.dialog.open(EditSampleComponent, {
      width: '90%',
      data: sampleId,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadHouseholdLetterTasks();
    });
  }

  editVoucher(voucherId: number) {
    const dialogRef = this.dialog.open(DialogEditVoucherComponent, {
      width: '90%',
      data: voucherId,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadVoucherLetterTasks();
    });
  }

  attachHoulseholdLetter(householdId: number, letterType: string, sampleId: number, parameterResultId: number) {
    this.householdAttachment = {
      id: 0,
      letterHtml: '',
      letterType: letterType,
      parameterResultId: parameterResultId,
      sampleId: sampleId,
      letterContent: '',
      householdId: householdId,
      base64File: ''
    };


    const dialogRef = this.dialog.open(AttachHouseholdLetterComponent, {
      width: '70%',
      data: this.householdAttachment,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadHouseholdLetterTasks();
    });
  }

  loadVoucherLetterTasks(){this.processingVouchers = true;

    this.voucherService.getVoucherLetterTasks().subscribe(
      result => {
        this.dashboardData.lettersTasks = result;
        this.dataSourceLetterTasks = new MatTableDataSource<VoucherLetter>(this.dashboardData.lettersTasks);
        this.processingVouchers = false;
      },
      error => {
        console.log(error);
        this.processingVouchers = false;
      },
      () => {
        this.dataSourceLetterTasks.paginator = this.paginator2;
        this.dataSourceLetterTasks.sort = this.sort2;
      }
    );
  }

  attachApplicationLetter(applicaitonId: number, letterType: string) {

    this.attachment = {
      id: 0,
      voucherId: 0,
      letterHtml: '',
      letterType: letterType,
      parameterResultId: 0,
      sampleId: 0,
      letterContent: '',
      voucherApplicationId: applicaitonId,
      quarter: 0,
      year: 0,
      tier: 0,
      testType: '',
      testsRequired: '',
      retestId: 0,
      wellAddress: '',
      customerName: '',
      mailingAddress: '',
      mailingCity: '',
      mailingState: '',
      mailingZip: '',
      phone: '',
      email: '',
      voucherIdentifier: '',
      base64File: ''
    }
    const dialogRef = this.dialog.open(AttachLetterComponent, {
      width: '70%',
      data: this.attachment,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadVoucherLetterTasks();
    });
  }

  attachVoucherLetter(id: number, voucherId: number, type: string, sampleId: number, parameterResultId: number) {

    this.attachment = {
      id: id,
      voucherId: voucherId,
      letterHtml: '',
      letterType: type,
      parameterResultId: parameterResultId,
      sampleId: sampleId,
      letterContent: '',
      voucherApplicationId: 0,
      quarter: 0,
      year: 0,
      tier: 0,
      testType: '',
      testsRequired: '',
      retestId: 0,
      wellAddress: '',
      customerName: '',
      mailingAddress: '',
      mailingCity: '',
      mailingState: '',
      mailingZip: '',
      phone: '',
      email: '',
      voucherIdentifier: '',
      base64File: ''
    }
    const dialogRef = this.dialog.open(AttachLetterComponent, {
      width: '70%',
      data: this.attachment,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadVoucherLetterTasks();
    });
  }

  generateNotEligible(letterType: string, applicationId: number, applicationType: string) {
    const generateLetter: VoucherLetterUpload = {
      id: 0,
      letterHtml: '',
      letterType: letterType,
      parameterResultId: 0,
      sampleId: 0,
      voucherId: 0,
      letterContent: '',
      voucherApplicationId: applicationId,
      quarter: 0,
      year: 0,
      tier: 0,
      testType: '',
      testsRequired: '',
      retestId: 0,
      wellAddress: '',
      customerName: '',
      mailingAddress: '',
      mailingCity: '',
      mailingState: '',
      mailingZip: '',
      phone: '',
      email: '',
      voucherIdentifier: '',
      base64File: ''
    }

    if (applicationType == this.voucherService.lubgwmaTestingVoucherType) {
      if (letterType == this.voucherService.notEligible) {
        const dialogRef = this.dialog.open(NotEligibleVoucherLetterComponent, {
          width: '90%',
          data: generateLetter,
        });
        dialogRef.afterClosed().subscribe(result => {
          this.loadVoucherLetterTasks();
        });
      }
      else {
        this.toastr.error("Unknown Letter Type.  Unable to generate.");
      }
    }
    else {
      this.toastr.error("Unknown Application Type.  Unable to generate.");
    }
  }

  generate(type: string, parameterResultId: number, sampleId: number, letterId: number, voucherId: number, applicationType: string) {

    const generateLetter: VoucherLetterUpload = {
      id: letterId,
      letterHtml: '',
      letterType: type,
      parameterResultId: parameterResultId,
      sampleId: sampleId,
      voucherId: voucherId,
      letterContent: '',
      voucherApplicationId: 0,
      quarter: 0,
      year: 0,
      tier: 0,
      testType: '',
      testsRequired: '',
      retestId: 0,
      wellAddress: '',
      customerName: '',
      mailingAddress: '',
      mailingCity: '',
      mailingState: '',
      mailingZip: '',
      phone: '',
      email: '',
      voucherIdentifier: '',
      base64File: ''
    }

    if (applicationType == this.voucherService.lubgwmaTestingVoucherType) {
      if (type == this.voucherService.voucherLetterType ||
        type == this.voucherService.voucherSelfSampleLetterType ||
        type == this.voucherService.voucherScheduleLetterType) {
        const dialogRef = this.dialog.open(LubgwmaTestingVoucherLetterComponent, {
          width: '90%',
          data: generateLetter,
        });
        dialogRef.afterClosed().subscribe(result => {
          this.loadVoucherLetterTasks();
        });
      }
      else if (type == this.voucherService.lubgwmaTreatmentLetterType) {
        if (parameterResultId != null && parameterResultId > 0) {
          const dialogRef = this.dialog.open(LubgwmaTreatmentVoucherLetterComponent, {
            width: '90%',
            data: generateLetter,
          });
          dialogRef.afterClosed().subscribe(result => {
            this.loadVoucherLetterTasks();
          });
        }
      }
      else {
        this.toastr.error("Unsupported Letter Type");
      }
    }
    else {
      this.toastr.error("Unknown Letter/Application Type");
    }
  }

  generateHouseholdLetter(letterType: string, parameterResultId: number, sampleId: number, householdId: number) {

    const generateLetter: HouseholdLetterUpload = {
      id: 0,
      letterHtml: '',
      letterType: letterType,
      parameterResultId: parameterResultId,
      sampleId: sampleId,
      letterContent: '',
      householdId: householdId,
      base64File: ''
    }

    if (letterType == this.householdService.householdExceedanceLetterType ||
        letterType == this.householdService.householdNoExceedanceLetterType) {
      const dialogRef = this.dialog.open(HouseholdExceedenceLetterComponent, {
        width: '90%',
        data: generateLetter,
      });
      dialogRef.afterClosed().subscribe(result => {
        this.loadHouseholdLetterTasks();
      });
    }
    
    else {
      this.toastr.error("Unsupported Letter Type");
    }
  }

  anchorToElement($element): void {
    $element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }
}